<template>
<div>
    <div>
        <div class="enroll-nav-div-wrap">
            <div class="enroll-nav-div">
                <a href="#" class="enroll-logo-link w-inline-block">
                    <img sizes="(max-width: 479px) 67.21875px, 84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" src="@/assets/images/Main_Logo.png" loading="lazy" class="enroll-nav-logo-image">
                </a>
            </div>
        </div>
    </div>
    <div>
        <div class="enroll-div-wrap">
            <!-- Slide 1 -->
            <div class="enroll-slide-1" v-if="active_el==1">
                <div class="w-form">
                    <form @submit.prevent="handleSubmit">
                        <div class="_0_herodiv">
                            <img sizes="(max-width: 479px) 28vw, 15vw" srcset="@/assets/images/stepsimage_teledoc_PM-p-500.png 500w, @/assets/images/stepsimage_teledoc_PM-p-500.png 641w" alt="" src="@/assets/images/stepsimage_teledoc_PM.png" loading="lazy" class="enroll-top-image">
                            <div class="enroll-header">Welcome to {{appName}}!</div>
                            <div class="enroll-sub">The following questions will be used by a board certified physician licensed in your state to help create a treatment plan for you. <br /><strong>Please answer all questions accurately.</strong></div>
                            <div class="enroll-disclaimer-div"><label class="w-checkbox enroll-checkbox-field"><input type="checkbox" v-model="people.agreed_to_terms" required name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox top"><span class="enroll-checkbox-label w-form-label" for="checkbox-3">I Agree to {{appName}}&#x27;s <a :href="`${appMainWeb}/terms`" target="_blank" class="enroll-checkbox-link">Terms</a>, <a :href="`${appMainWeb}/privacy`" target="_blank" class="enroll-checkbox-link">Privacy Policy</a> and consent to <a :href="`${appMainWeb}/telehealth-consent`" target="_blank" class="enroll-checkbox-link">Telehealth</a></span></label></div>
                            <div class="enroll-3-things-div">
                                <div class="enroll-bullet-div">
                                    <img loading="lazy" src="@/assets/images/icon_testing-check-copy.svg" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">Free online medical evaluation</div>
                                </div>
                                <div class="enroll-bullet-div">
                                    <img loading="lazy" src="@/assets/images/icon_doctor-check-copy.svg" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">Board-certified physicians</div>
                                </div>
                                <div class="enroll-bullet-div">
                                    <img loading="lazy" src="@/assets/images/icon_delivery-check-copy.svg" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">Fast free shipping</div>
                                </div>
                            </div>

                            <div class="enroll-form-button-div"><input type="submit" data-wait="Please wait..." class="enroll-form-submit-button top w-button" value="Start my FREE visit -&gt;"></div>
                        </div>
                    </form>
                    <div class="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div class="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                </div>
            </div>

            <!-- Slide 2 -->
            <div class="enroll-slide-2 addmargin-mobile" v-if="active_el==2">
                <div class="enroll-form-header-div">
                    <div class="enroll-form-header-text">Let's start with the Basics</div>
                </div>

                <div class="enroll-form-block update w-form">
                    <form @submit.prevent="handleSubmit" class="enroll-form update">
                        <h1 class="enroll-form-question-text smaller a">Let's make sure we are licensed in your state</h1>
                        <select id="State-4" name="State-4" data-name="State 4" required v-model="people.state" class="select-field-3 form update w-select">
                            <option value="" disabled selected>State...</option>
                            <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}</option>
                        </select>

                        <h1 class="enroll-form-question-text smaller a">Who do I have the pleasure of talking to?</h1>
                        <div class="enroll-form-field-wrap-div update">
                            <input class="text-field-33 update w-input" maxlength="256" name="name" data-name="Name" v-model="people.first_name" placeholder="First Name" type="text" id="name">
                            <input class="text-field-33 update w-input" maxlength="256" v-model="people.last_name" name="Last-name" data-name="Last Name" placeholder="Last Name" type="text" id="Last-name" required>
                        </div>

                        <h1 class="enroll-form-question-text smaller">What was your gender at birth?</h1>
                        <div class="div-block-1893">
                            <label class="w-checkbox checkbox-field-18 male">
                                <input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" :checked="people.gender === 'Male'" @change="updateGender('Male')" class="w-checkbox-input enroll-checkbox">
                                <span class="checkbox-label-15 w-form-label" for="checkbox-4">Male</span>
                            </label>

                            <label class="w-checkbox checkbox-field-18 female">
                                <input type="checkbox" name="checkbox-4" id="male-checkbox" class="w-checkbox-input enroll-checkbox" :checked="people.gender === 'Female'" @change="updateGender('Female')">
                                <span class="checkbox-label-15 w-form-label" for="female-checkbox">Female</span>
                            </label>

                        </div>

                        <h1 class="enroll-form-question-text smaller">Please enter your email</h1>
                        <input class="text-field-33 email form update w-input" :class="{'email-error-input': emailCheckError}" v-model="people.email" @blur="onEmailBlur" maxlength="256" name="Email-2" data-name="Email 2" placeholder="Enter your email" type="email" id="Email-2" required>
                        <div v-if="emailCheckError" class="email-check-error">{{ emailCheckError }}</div>

                        <h1 class="enroll-form-question-text smaller">Please enter your mobile number {{ tempvalue }}</h1>
                        <div class="phone-entry-div update">
                            <input class="phone-number-field _1 form update w-input" @input="handlePhoneInput($event, 'areaCode')" pattern="[0-9]*" inputmode="tel" ref="areaCode" name="phone-area" data-name="Field 2" placeholder="(000)" v-model="people.phone_parts.areaCode" type="tel" autocomplete="tel" id="phone-area" required>
                            <div class="text-block-142">-</div>
                            <input class="phone-number-field form update w-input" @input="handlePhoneInput($event, 'prefix')" pattern="[0-9]*" inputmode="tel" ref="prefix" maxlength="3" name="phone-prefix" data-name="Field 2" placeholder="000" type="tel" v-model="people.phone_parts.prefix" id="phone-prefix" required>
                            <div class="text-block-142">-</div>
                            <input class="phone-number-field _2 form update w-input" @input="handlePhoneInput($event, 'line')" pattern="[0-9]*" inputmode="tel" ref="line" maxlength="4" name="phone-line" data-name="Field 2" placeholder="0000" type="tel" v-model="people.phone_parts.line" id="phone-line" required>
                        </div>

                        <p class="sms-marketing-disclaimer">By providing your phone number, you agree to receive marketing text messages from Priority Meds. Message and data rates may apply. Message frequency varies. Send HELP for help or STOP to opt out. All information collected during the SMS opt-in process will not be sold, rented, or shared. View our <a href="https://prioritymeds.com/sms-terms-conditions" target="_blank" class="enroll-checkbox-link">SMS Terms</a> and <a :href="`${appMainWeb}/privacy`" target="_blank" class="enroll-checkbox-link">Privacy Policy</a>.</p>

                        <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                        <button type="submit" class="enroll-form-submit-button w-button" :disabled="emailChecking" style="border:none;cursor:pointer;">
                            {{ emailChecking ? 'Please wait...' : 'Next ->' }}
                        </button>

                        <div class="enroll-disclaimer-div form"><label class="w-checkbox enroll-checkbox-field form" :class="{ 'field-error': formErrors.emailConsent }"><input v-model="people.agreed_to_email" type="checkbox" name="checkbox-email" id="checkbox-email" data-name="Checkbox Email" class="w-checkbox-input enroll-checkbox"><span class="enroll-checkbox-label form w-form-label" for="checkbox-email">By checking this box, I also consent by electronic signature to receive informational and transactional phone calls and/or SMS text messages at the phone number(s) above, including my wireless number if provided. I understand these calls may be generated using an automated technology, pre-recorded voices, and that data rates may apply.</span></label></div>
                        <div v-if="formErrors.emailConsent" class="email-check-error">{{ formErrors.emailConsent }}</div>

                        <div class="w-form-fail" style="display:block;" v-if="hasStep2SummaryErrors">
                            <template v-for="(message, field) in formErrors">
                                <div v-if="field !== 'emailConsent'" :key="field">{{ message }}</div>
                            </template>
                        </div>
                    </form>

                </div>

                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Slide 3 -->
            <div class="enroll-slide-3 addmargin-mobile" v-if="active_el === 3">
                <h1 class="enroll-form-question-text">What is your date of birth?</h1>
                <p class="enroll-form-question-sub">Based on your date of birth our doctors can prescribe the proper prescription.</p>
                <div class="enroll-form-block b w-form">
                    <form @submit.prevent="validateDOB" class="enroll-form b">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="enroll-form-input-div mobile-entry form _2 weight">
                                <select v-model="people.dob.mm" class="select-field-5 felix w-select" required>
                                    <option value="">Month</option>
                                    <option value="01">January</option>
                                    <option value="02">February</option>
                                    <option value="03">March</option>
                                    <option value="04">April</option>
                                    <option value="05">May</option>
                                    <option value="06">June</option>
                                    <option value="07">July</option>
                                    <option value="08">August</option>
                                    <option value="09">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                                <div class="text-block-518">-</div>
                                <input class="phone-number-field-3 form birth felix w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" v-model="people.dob.dd" placeholder="Day" type="text" @input="handleNumericInput($event, 'dob.dd', 2, 31)" required>
                                <div class="text-block-518">-</div>
                                <input class="phone-number-field-3 _2 form birth felix w-input" maxlength="4" pattern="[0-9]*" inputmode="numeric" v-model="people.dob.yyyy" placeholder="Year" type="text" @input="handleNumericInput($event, 'dob.yyyy', 4)" required>
                            </div>
                        </div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button b w-button" value="Next -&gt;">
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>

                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Slide 4 -->
            <div class="enroll-slide-3 addmargin-mobile" v-if="active_el==4">
                <h1 class="enroll-form-question-text">What is your height and weight?</h1>
                <p class="enroll-form-question-sub">We'll use this to determine your Body mass Index (BMI) for diagnosis. remember, BMI is a measure of size - not health</p>
                <div class="enroll-form-block b w-form">
                    <form class="enroll-form b" @submit.prevent="handleSubmit">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="enroll-form-input-div mobile-entry form _2 height top">
                                <input class="enroll-form-text-field height w-input" maxlength="1" v-model="people.height.foot" @input="handleNumericInput($event, 'height.foot', 1); calculateBMI()" name="feet" data-name="Feet" pattern="[0-9]*" inputmode="numeric" placeholder="Feet" type="text" id="feet" required>
                                <div class="field-label-text">ft.</div>
                                <input class="enroll-form-text-field height update w-input" maxlength="2" v-model="people.height.inches" @input="handleNumericInput($event, 'height.inches', 2, 11); calculateBMI()" name="inches" pattern="[0-9]*" inputmode="numeric" data-name="Inches" placeholder="Inches" type="text" id="inches" required>
                                <div class="field-label-text last">in.</div>
                            </div>
                            <div class="enroll-form-input-div mobile-entry form _2 weight">
                                <input class="enroll-form-text-field weight w-input" maxlength="3" name="weight-2" v-model="people.weight" @input="handleNumericInput($event, 'weight', 3); calculateBMI()" pattern="[0-9]*" inputmode="numeric" data-name="Weight 2" placeholder="Weight in pounds" type="text" id="weight-2" required>
                                <div class="field-label-text weight">lbs.</div>
                            </div>
                            <div v-if="people.bmi" class="bmi-result">
                                Your BMI: {{ people.bmi.toFixed(1) }}
                            </div>
                        </div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button b w-button" value="Next -&gt;">
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>

                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Slide 5 -->

            <div class="enroll-slide-3 addmargin-mobile" v-if="active_el==5">
                <h1 class="enroll-form-question-text">What is your <strong>desired weight </strong>?</h1>
                <div class="enroll-form-block b update w-form">
                    <form class="enroll-form b" @submit.prevent="handleSubmit">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="enroll-form-input-div mobile-entry form _2 weight"><input class="enroll-form-text-field weight w-input" maxlength="3" pattern="[0-9]*" inputmode="numeric" name="Goal-Weight" v-model="people.desired_weight" @input="handleNumericInput($event, 'desired_weight', 3)" data-name="Goal Weight" placeholder="What is your goal weight in pounds?" type="text" id="Goal-Weight" required>
                                <div class="field-label-text weight">lbs.</div>
                            </div>
                        </div>
                        <button type="submit" class="enroll-form-submit-button b w-button" style="padding-top: 12px;" :disabled="isSubmitting">
                            <div v-if="isSubmitting">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1">
                                        </animateTransform>
                                    </circle>
                                </svg>
                            </div>
                            <div v-else>
                                Start my FREE visit ->
                            </div>
                        </button>
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>

                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

        </div>
    </div>
    <!-- Paid User Modal -->
    <div v-if="showPaidUserModal" class="paid-user-modal-overlay" @click.self="dismissPaidUserModal">
        <div class="paid-user-modal">
            <button class="paid-user-modal-close" aria-label="Close" @click="dismissPaidUserModal">&times;</button>
            <h3 class="paid-user-modal-title">Welcome back!</h3>
            <p class="paid-user-modal-body">{{ paidUserModalMessage || 'You already have an account with us. Log in to manage your treatment, track shipments, and message your care team.' }}</p>
            <div class="paid-user-modal-buttons">
                <button class="paid-user-modal-btn login" @click="goToLogin">Log In</button>
                <button class="paid-user-modal-btn not-me" @click="useDifferentEmail">Not me &mdash; use a different email</button>
            </div>
        </div>
    </div>

    <div style="height: 420px;"></div>
</div>
</template>

<script>
import state from "@/utils/state.json"
import { checkEmail } from "@/utils/checkEmail"
import {
    mapActions
} from 'vuex'
export default {
    name: 'WeightLossForm2',
    data() {
        return {
            allState: state,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            appName: process.env.VUE_APP_COMPANY,
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            active_el: 1,
            tempvalue: '',
            formErrors: {},
            isSubmitting: false,
            emailChecking: false,
            emailCheckError: '',
            showPaidUserModal: false,
            paidUserModalMessage: '',
            emailCheckPassed: false,

            people: {
                form_type: "home_page_form",
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                phone_parts: {
                    areaCode: '',
                    prefix: '',
                    line: ''
                },
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agreed_to_email: false,
                desired_weight: '',
                state: '',
                agreed_to_terms: true,
                form_step2_agree: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                ip_address: '',
                age: '',
                tracking_session_id:'',
                user_agent:'',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
            }
        }
    },
    async mounted() {
        if (this.$route.query.sema) {
            await this.$store.dispatch('addSemaOffer', this.$route.query.sema);
        }
        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
        this.getIpAddress();
    },
    computed: {
        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },
        hasStep2SummaryErrors() {
            return Object.keys(this.formErrors).some(field => field !== 'emailConsent');
        },
        isValidPhone() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            // Check if all parts exist and are the correct length
            return (
                areaCode?.length === 3 &&
                prefix?.length === 3 &&
                line?.length === 4 &&
                /^\d+$/.test(areaCode) &&
                /^\d+$/.test(prefix) &&
                /^\d+$/.test(line)
            );
        },
        phoneNumber() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            if (!this.isValidPhone) return '';
            return `${areaCode}${prefix}${line}`;
        },
        isValidEmail() {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(this.people.email);
        },
        calculatedBMI() {
            if (this.people.weight && this.people.heightInInches) {
                const heightInInches = parseFloat(this.people.heightInInches);
                const weightInPounds = parseFloat(this.people.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            }
            return null;
        }
    },
    methods: {
        ...mapActions([
            'setCartVisibility'
        ]),
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        GoBack() {
            this.active_el--;
        },
        goToLogin() {
            this.showPaidUserModal = false;
            this.$router.push({ path: '/login', query: { email: this.people.email } }).catch(err => {
                if (err.name !== 'NavigationDuplicated' && !/redirected/i.test(err.message || '')) {
                    throw err;
                }
            });
        },
        dismissPaidUserModal() {
            this.showPaidUserModal = false;
        },
        useDifferentEmail() {
            this.showPaidUserModal = false;
            this.emailCheckPassed = false;
            this.$nextTick(() => {
                const emailInput = document.getElementById('Email-2');
                if (emailInput) emailInput.focus();
            });
        },
        async onEmailBlur() {
            if (!this.isValidEmail) {
                this.emailCheckError = '';
                this.emailCheckPassed = false;
                return;
            }
            await this.runEmailCheck();
        },
        async runEmailCheck() {
            this.emailChecking = true;
            this.emailCheckError = '';
            try {
                const result = await checkEmail(this.people.email);
                if (!result.proceed) {
                    if (result.reason === 'paid_user') {
                        this.emailCheckError = 'This email is already taken. Please choose a different email or log into your account.';
                        this.paidUserModalMessage = 'You already have an account with us. Log in to manage your treatment, track shipments, and message your care team.';
                        this.showPaidUserModal = true;
                        this.emailCheckPassed = false;
                    } else if (result.reason === 'wrong_role') {
                        this.emailCheckError = 'This email is already taken. Please choose a different email or log into your account.';
                        this.paidUserModalMessage = `This email is associated with a ${result.role} account. Please log in to continue, or use a different email.`;
                        this.showPaidUserModal = true;
                        this.emailCheckPassed = false;
                    }
                } else {
                    this.emailCheckPassed = true;
                }
            } finally {
                this.emailChecking = false;
            }
        },
        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            // Check if the date is valid
            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            // Ensure the year is between 1924 and the current year
            const currentYear = today.getFullYear();
            if (year < 1924 || year > currentYear) {
                return false;
            }

            // Ensure the date is not in the future
            if (date > today) {
                return false;
            }

            return true;
        },
        validateDOB() {
            const {
                mm,
                dd,
                yyyy
            } = this.people.dob

            // Add padding to month and day
            const paddedMonth = String(mm).padStart(2, '0');
            const paddedDay = String(dd).padStart(2, '0');

            if (!this.isValidDate(paddedMonth, paddedDay, yyyy)) {
                this.isError = true
                return
            }

            this.people.dobMMDDYYYY = `${paddedMonth}/${paddedDay}/${yyyy}`

            this.active_el++;
            this.isError = false
        },
        handleNumericInput(event, path, maxLen, maxVal) {
            let value = event.target.value.replace(/\D/g, '').slice(0, maxLen);
            if (maxVal && value !== '' && Number(value) > maxVal) {
                value = String(maxVal);
            }
            const keys = path.split('.');
            let obj = this.people;
            for (let i = 0; i < keys.length - 1; i++) {
                obj = obj[keys[i]];
            }
            obj[keys[keys.length - 1]] = value;
            event.target.value = value;
        },
        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches)
            const weightInPounds = parseInt(this.people.weight)
            this.people.bmi = (weightInPounds * 703) / (heightInInches * heightInInches)
            this.people.heightInInches = heightInInches;

        },
        updateGender(selectedGender) {
            // Toggle the gender selection
            this.people.gender = this.people.gender === selectedGender ? null : selectedGender;
        },
        validateStep1() {
            this.formErrors = {};
            if (!this.people.agreed_to_terms) {
                this.formErrors.terms = 'Please agree to the terms and conditions';
                return false;
            }
            try{
                if (window.tracking){
                    window.tracking.event('questionnaire_start', {});
                }
            }catch(error){
                console.log(error)
            }
            return true;
        },
        async validateStep2() {
            this.formErrors = {};

            if (!this.people.state) {
                this.formErrors.state = 'Please select your state';
                return false;
            }

            if (!this.people.first_name || !this.people.last_name) {
                this.formErrors.name = 'Please enter your full name';
                return false;
            }

            if (!this.people.gender) {
                this.formErrors.gender = 'Please select your gender';
                return false;
            }

            if (!this.isValidEmail) {
                this.formErrors.email = 'Please enter a valid email address';
                return false;
            }

            // Run email check on submit if not already passed
            if (!this.emailCheckPassed) {
                await this.runEmailCheck();
                if (!this.emailCheckPassed) {
                    return false;
                }
            }

            if (!this.people.agreed_to_email) {
                this.formErrors.emailConsent = 'Please agree to receive SMS communications to continue';
                return false;
            }

            if (!this.isValidPhone) {
                this.formErrors.phone = 'Please enter a complete, valid phone number';
                return false;
            }
            try{
                if (window.tracking){
                    window.tracking.event('partial', {});
                }
            }catch(error){
                console.log(error)
            }
            return true;
        },
        validateStep3() {
            this.formErrors = {};

            const foot = parseInt(this.people.height.foot);
            const inches = parseInt(this.people.height.inches);
            const weight = parseFloat(this.people.weight);

            if (isNaN(foot) || isNaN(inches) || foot < 4 || foot > 8 || inches < 0 || inches > 11) {
                this.formErrors.height = 'Please enter a valid height';
                return false;
            }

            if (isNaN(weight) || weight < 80 || weight > 700) {
                this.formErrors.weight = 'Please enter a valid weight';
                return false;
            }

            // Calculate height in inches
            this.people.heightInInches = (foot * 12) + inches;
            // Calculate BMI
            this.people.bmi = this.calculatedBMI;

            try{
                if (window.tracking){
                    window.tracking.event('bmi_confirmation', {});
                }
            }catch(error){
                console.log(error)
            }
            return true;
        },

        validateStep4() {
            this.formErrors = {};

            const desiredWeight = parseFloat(this.people.desired_weight);
            const currentWeight = parseFloat(this.people.weight);

            if (isNaN(desiredWeight) || desiredWeight < 80 || desiredWeight > 700) {
                this.formErrors.desiredWeight = 'Please enter a valid desired weight';
                return false;
            }

            if (desiredWeight >= currentWeight) {
                this.formErrors.desiredWeight = 'Desired weight should be less than current weight';
                return false;
            }

            return true;
        },

        async handleSubmit() {
            if (["LA", "MS"].includes(this.people.state)) {
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "Unfortunately, our GLP Medical Weight Loss program is not yet available in your state. However, we're excited to announce that it will be launching next month!"
                    }
                });
                return false;
            }
            this.formErrors = {};
            let isValid = false;

            switch (this.active_el) {
                case 1:
                    isValid = this.validateStep1();
                    break;
                case 2:
                    isValid = await this.validateStep2();
                    break;
                case 3:
                    isValid = true;
                    break;
                case 4:
                    isValid = this.validateStep3();
                    break;
                case 5:
                    isValid = this.validateStep4();
                    break;
            }

            if (!isValid) {
                return;
            }

            if (this.active_el < 5) {
                this.active_el++;
                return;
            }

            // Final submission
            this.finalSubmit();

        },
        async finalSubmit() {
            try {
                if (this.people.dob.yyyy > 2006) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years. "
                        }
                    });
                    return false;
                }
                this.isSubmitting = true;
                this.people.phone = this.phoneNumber;
                this.people.user_agent = window.navigator.userAgent;
                try{
                    this.people.tracking_session_id = await window.tracking.assertSession();
                }catch(error){
                    if(window.trackingSessionId){
                        this.people.tracking_session_id = window.trackingSessionId;
                    }
                }
                
                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, this.people, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                })
                if (response.data.status === 'success') {

                    try{
                        if (window.tracking){
                            window.tracking.event('questionnaire_end', {});
                        }
                    }catch(error){
                        console.log(error)
                    }

                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.$router.push({
                        name: 'reportPage',
                        query: {
                            'desiredWeight': this.people.desired_weight
                        }
                    });

                    
                }
            } catch (error) {
                console.error('Form submission error:', error);
                this.formErrors.submission = 'There was an error submitting your form. Please try again.';
            } finally {
                this.isSubmitting = false;
            }

        },
        goBack() {
            if (this.active_el > 1) {
                this.active_el--;
            }
        },

        handlePhoneInput(event, field) {
            let value = event.target.value.replace(/\D/g, '');

            // Handle country code prefix (e.g. +1)
            if (value.length === 11 && value.startsWith('1')) {
                value = value.slice(1);
            }

            // Autofill: full phone number pasted into one field
            if (value.length >= 10) {
                this.people.phone_parts.areaCode = value.slice(0, 3);
                this.people.phone_parts.prefix = value.slice(3, 6);
                this.people.phone_parts.line = value.slice(6, 10);
                event.target.blur();
                setTimeout(() => {
                    this.$refs.line?.focus();
                }, 100);
                return;
            }

            const maxLength = {
                areaCode: 3,
                prefix: 3,
                line: 4
            } [field];

            this.people.phone_parts[field] = value.slice(0, maxLength);

            // Auto-focus next field
            if (value.length >= maxLength) {
                const nextField = {
                    areaCode: 'prefix',
                    prefix: 'line'
                } [field];

                if (nextField) {
                    this.$refs[nextField]?.focus();
                }
            }

        },

        handleGenderSelection(gender) {
            this.people.gender = gender;
        }
    },
    watch: {
        calculatedBMI(newBMI) {
            this.people.bmi = newBMI;
        },
        active_el() {
            window.scrollTo(0, 0)
        },
        'people.email'() {
            this.emailCheckPassed = false;
            this.emailCheckError = '';
        },
        'people.agreed_to_email'(checked) {
            if (checked && this.formErrors.emailConsent) {
                this.$delete(this.formErrors, 'emailConsent');
            }
        }
    }
}
</script>

<style scoped>
.enroll-top-image {
    width: 9%;
    margin-bottom: 15px;
}

.dob-page {
    width: 80% !important;
}

.checkbox-field-18.female {
    background-image: url(@/assets/images/Female.svg);
    background-size: 8%;
}

.checkbox-field-18.male {
    background-image: url(@/assets/images/Male.svg);
    background-size: 8%;
}

@media screen and (max-width: 479px) {
    .checkbox-field-18.female {
        background-size: 13%;
    }

    .checkbox-field-18.male {
        background-size: 13%;
    }

    .addmargin-mobile {
        margin-top: 20px;
    }
}

.bmi-result {
    margin: 20px 0;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
}

.dob-feild {
    width: 33%;
}

@media screen and (max-width: 479px) {
    .enroll-header {
        font-size: 28px;
    }
    .dob-feild {
        width: 100%;
    }

    .enroll-top-image {
        width: 30%;
        margin-left: -5px;
        display: none;
    }

    .enroll-nav-div {
        text-align: center;
        justify-content: center;
        align-items: center;
        display: flex;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    select#State-4 {
        font-size: 18px;
    }

    .select-field-9 {
        font-size: 18px;
    }
}

.enroll-checkbox-field.field-error .w-checkbox-input {
    border-color: #e74c3c;
}

.enroll-checkbox-field.field-error .enroll-checkbox-label {
    color: #e74c3c;
}

.email-error-input {
    border: 2px solid #e74c3c !important;
    background-color: #fdf0ef !important;
}

.email-check-error {
    color: #e74c3c;
    font-size: 13px;
    margin-top: 4px;
    margin-bottom: 8px;
}

.sms-marketing-disclaimer {
    font-size: 12px;
    line-height: 1.5;
    color: #666;
    margin: -28px 0 16px;
}

.sms-marketing-disclaimer a {
    color: #666;
    text-decoration: underline;
}

.enroll-disclaimer-div.form {
    margin-top: 24px;
}

.paid-user-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.paid-user-modal {
    position: relative;
    background: #fff;
    border-radius: 14px;
    padding: 32px 28px 24px;
    max-width: 420px;
    width: 90%;
    text-align: center;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.18);
}

.paid-user-modal-close {
    position: absolute;
    top: 10px;
    right: 14px;
    background: transparent;
    border: none;
    font-size: 24px;
    line-height: 1;
    color: #888;
    cursor: pointer;
    padding: 4px 8px;
}

.paid-user-modal-close:hover {
    color: #333;
}

.paid-user-modal-title {
    font-size: 22px;
    font-weight: 700;
    color: #111;
    margin: 4px 0 12px;
}

.paid-user-modal-body {
    font-size: 15px;
    line-height: 1.5;
    margin: 0 0 24px;
    color: #4a4a4a;
}

.paid-user-modal-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.paid-user-modal-btn {
    padding: 14px 20px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid transparent;
    width: 100%;
}

.paid-user-modal-btn.login {
    background: #2e9bf0;
    color: #fff;
}

.paid-user-modal-btn.login:hover {
    background: #1e86d8;
}

.paid-user-modal-btn.not-me {
    background: #fff;
    color: #1f2430;
    border-color: #d8dce3;
}

.paid-user-modal-btn.not-me:hover {
    background: #f5f6f8;
}
</style>
